import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./_assets/css/global.css";
import "./_assets/css/ol.css";
import "./_assets/css/theme-sema.css";
import 'shepherd.js/dist/css/shepherd.css';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-green/theme.css";
import { PrimeReactProvider } from "primereact/api";



import ReactDOM from "react-dom";
import Welcome from "./features/Welcome/index";
import "./i18n";

ReactDOM.render(
  <PrimeReactProvider>
    <Welcome />
  </PrimeReactProvider>,

  document.getElementById("root")
);
